/* --------------------------------------------------
Import modules
-------------------------------------------------- */

import Breakpoint from '../classes/breakpoints';

/* --------------------------------------------------
Breakpoints
-------------------------------------------------- */

window.DynamicBreakpoints = [];
[...document.querySelectorAll('[data-breakpoint]')].forEach(el => DynamicBreakpoints.push(new Breakpoint(el)));
window.addEventListener('scripts-loaded', () => {
  DynamicBreakpoints.forEach(instance => {
    instance.toggleClass();
    instance.container.classList.add('js-breakpoint--loaded');
  });
});